/**
 * Single source of truth for build-time static generation.
 * Plain module (no imports) so both the app entry and vite.config.ts can use it.
 */
export const SITE_URL = "https://thealphaomegahub.com";

/** Indexable pages: pre-rendered AND listed in sitemap.xml. */
export const PUBLIC_STATIC = ["/", "/blog", "/case-studies", "/terms", "/privacy", "/resources", "/lm/appointment-setting", "/lm/posting", "/lm/script-builder", "/lm/ad-script-builder", "/lm/video-ad"];

/** Private pages: pre-rendered (so no other page's markup is served there) but never in the sitemap. */
export const PRIVATE_STATIC = [
  "/aa", "/kj", "/full", "/vsl", "/welcome", "/content", "/taohmathis", "/booked", "/book", "/filled", "/start", "/contract", "/simulator", "/scheduler",
  "/services/video-shooting", "/services/website-creation", "/services/ads-management",
];

export const isPublicRoute = (p: string) =>
  PUBLIC_STATIC.includes(p) || /^\/blog\/[^/:]+$/.test(p) || /^\/case-studies\/[^/:]+$/.test(p);

export const isPrivateRoute = (p: string) => PRIVATE_STATIC.includes(p);
